import type { AuthResponse } from '@supabase/supabase-js'

import getClient from './getClient'

interface VerifyOtpProps {
  code: string
  email: string
}

export default function verifyOtp({
  code,
  email,
}: VerifyOtpProps): Promise<AuthResponse> {
  return getClient().auth.verifyOtp({
    email,
    token: code,
    type: 'email',
  })
}
